
//
// Turbo Button

turboButton = {};

turboButton.create = function() {
	var button = new PIXI.Container();

	InputHelpers.addGenerics(button);
	button._flags.reelsSpinning = false;
	button._flags.turboActive = false;
	button._slamStopButton = undefined;

	button.canEnable = function() {
		return (!this._flags.modal.active);
	};

	button.onPressedCallback = function() {
		this._flags.turboActive = !this._flags.turboActive;

		if (this._flags.turboActive && this._flags.reelsSpinning && (this._slamStopButton !== undefined)) {
			this._slamStopButton.onPressedCallback();
			if (button.soundName !== "") button.playSound();
		}
	};

	button.reelSpinStarted = function(spinTask) {
		this._flags.reelsSpinning = true;

		if (this._flags.turboActive && (this._slamStopButton !== undefined)) {
			this._slamStopButton.onPressedCallback();
		}
	};

	button.reelSpinEnded = function() {
		this._flags.reelsSpinning = false;
	};

	messageBus.subscribe("spinner:SpinEvent", button.reelSpinStarted.bind(button));
	messageBus.subscribe("spinner:SpinEventDead", button.reelSpinEnded.bind(button));

	return button;
};

turboButton.initialise = function(json, object) {
	if (json.slamStopButtonName !== undefined) {
		object._slamStopButton = resourceManager.get(json.slamStopButtonName);
	}
	object.soundName = json.soundName || "";
};
turboButton.getFilesRequired = function() {
	return [];
};

resourceManager.registerObjectType("turboButton", turboButton.create, turboButton.initialise, turboButton.getFilesRequired);